// Hardcoded overrides for brand links that should bypass the normal
// brand-page URL (e.g. routing to an aggregate/off-site page instead).
export const BRAND_LINK_OVERRIDES = {
    'Ray-Ban': 'https://www.coolframes.com/shop/ray-ban-eyewear',
};

export function resolveBrandLink(name, fallbackUrl) {
    return BRAND_LINK_OVERRIDES[name] || fallbackUrl;
}
